module.exports = __webpack_public_path__ + "img/040-invoice.c6fcfc7c.svg";